<div class="sign-in" *transloco="let t; read: 'global.mfa'">
  <logo class="sign-in__logo"></logo>

  <ui-language class="root__language" [horizontal]="true" [lightBackground]="true" [languages]="uiLanguages$ | async"
               [currentLanguage]="currentLanguage$ | async" (languageChanged)="languageChanged($event)">
  </ui-language>

  <!-- Loading state -->
  <div *ngIf="loading" class="mfa__loading">
    <div class="mfa__loading__spinner"></div>
    <p class="mfa__loading__text">{{ t('loading') }}</p>
  </div>

  <!-- Content when loaded -->
  <div *ngIf="!loading">
    <div class="sign-in__form__hint">{{ t('verificationIntro') }}</div>

    <form class="sign-in__form" [formGroup]="form" (ngSubmit)="verify()" novalidate>
      <ha-input
        type="text"
        class="sign-in__form__input"
        formControlName="verificationCode"
        [label]="t('codeLabel')"
        autocomplete="one-time-code"
        inputmode="numeric"
        [maxlength]="6"
        placeholder="000000">
      </ha-input>

      <!-- Error Display -->
    <div *ngIf="error" class="sign-in__form__error-message">
      {{ t(error) }}
    </div>

      <button class="sign-in__form__button" type="submit" [disabled]="saving || form.invalid">
        <span *ngIf="saving">{{ t('verifying') }}...</span>
        <span *ngIf="!saving">{{ t('verify') }}</span>
      </button>
    </form>

    <div class="sign-in__forgot-password">
      <a class="sign-in__forgot-password__anchor" routerLink="/login">
        <ng-container *transloco="let tGlobal; read: 'global'">{{ tGlobal('backToLogin') }}</ng-container>
      </a>
    </div>
  </div>
</div>
